



























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  DrivewealthAccountManagementType,
} from "@/shared/types";
import * as SharedRoutes from "@/shared/route-names";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({ components: {} })
export default class InstrumentName extends Vue {
  @Prop({ required: true }) website: string;
  @Prop({ required: true }) companyName: string;
  @Prop({ required: true }) symbol: string;
  @Prop({ required: true }) imageUrl: string;
  @Prop({ required: false }) accountId?: number;
  @Prop({ required: false }) displaySymbol: string;
  @Prop({ required: false }) isEtfOrEquity: boolean;
  @Prop({ required: false }) isMutualFund: boolean;

  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();
  SharedRoutes = SharedRoutes;

  get displayInstrumentPerformanceLink (): boolean {
    return this.featureFlagStore.flags.bend24761DisplayInstrumentPerformanceView &&
        this.accountId !== undefined && (this.isEtfOrEquity || this.featureFlagStore.flags.bend29829EnablePerformancePageForMF);
  }

  openInstrumentUrl (): void {
    this.drivewealthStore.openInstrumentDetailFundResearchUrl({ stockSymbol: this.symbol, fallbackUrl: this.website });
  }
}
